import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { I18nProvider } from './context/I18nContext';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import IncidenciasDisplay from './pages/IncidenciasDisplay';
import XIAStandalone from './pages/XIAStandalone';
import XIAMainChat from './pages/XIAMainChat';
import HomeSelector from './pages/HomeSelector';
import FichadorPanel from './pages/FichadorPanel';
import AlcazarPreguntas from './pages/AlcazarPreguntas';
import AlcazarDashboard from './pages/AlcazarDashboard';

// Loading component with logo
function LoadingScreen() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-600 to-blue-800 flex items-center justify-center">
      <div className="text-center">
        <img
          src="/logo-xia.svg"
          alt="XIA"
          className="h-20 mx-auto animate-pulse"
          style={{ filter: 'brightness(0) invert(1)' }}
        />
        <p className="mt-4 text-white/80">Cargando...</p>
      </div>
    </div>
  );
}

// Protected route wrapper
function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated) {
    return <Navigate to={`/login?next=${encodeURIComponent(window.location.pathname)}`} replace />;
  }

  return children;
}

// Public route (redirects to dashboard if already logged in)
function PublicRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <LoadingScreen />;
  }

  if (isAuthenticated) {
    return <Navigate to="/alcazar/dashboard" replace />;
  }

  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route
        path="/login"
        element={
          <PublicRoute>
            <Login />
          </PublicRoute>
        }
      />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Navigate to="/alcazar/dashboard" replace />
          </ProtectedRoute>
        }
      />
      <Route
        path="/chat"
        element={
          <ProtectedRoute>
            <XIAMainChat />
          </ProtectedRoute>
        }
      />
      <Route
        path="/comercial"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      {/* Pantalla de incidencias en tiempo real - acceso sin login para monitores */}
      <Route path="/pantallas" element={<IncidenciasDisplay />} />
      <Route path="/incidencias" element={<IncidenciasDisplay />} />
      <Route path="/display" element={<IncidenciasDisplay />} />
      <Route path="/display/:pin" element={<IncidenciasDisplay />} />
      {/* XIA Standalone - Acceso directo con login propio */}
      <Route path="/xia" element={<XIAStandalone />} />
      {/* Alcázar - Panel de preguntas y respuestas XIA (requiere login) */}
      <Route path="/alcazar" element={
        <ProtectedRoute>
          <AlcazarPreguntas />
        </ProtectedRoute>
      } />
      {/* Alcázar - Dashboard de monitorización XIA (requiere login) */}
      <Route path="/alcazar/dashboard" element={
        <ProtectedRoute>
          <AlcazarDashboard />
        </ProtectedRoute>
      } />
      {/* Fichador - Panel de control de presencia (requiere login) */}
      <Route path="/fichador" element={
        <ProtectedRoute>
          <FichadorPanel />
        </ProtectedRoute>
      } />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <I18nProvider>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </I18nProvider>
    </BrowserRouter>
  );
}

export default App;
